import { CIMSPage, DSStatus, Permission } from '@cims-online/shared'
import { useDesignSubmittalLogContext } from '../../../../DesignSubmittalLogContext'
import { useCreateDesignSubmittalCommentMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { ExpandOptions } from 'components/CIMSTable/CIMSTableContext/types/expand'
import SingleUser from 'components/SingleUser'
import { DesignSubmittal } from '../../../../DesignSubmittalLogContext/types'

export function useExpandOptions(): ExpandOptions<DesignSubmittal> {
  const { refetch, edit } = useDesignSubmittalLogContext()
  const [createComment] = useCreateDesignSubmittalCommentMutation({
    ...DefaultMutationHookOptions,
  })
  return {
    render: ({
      id,
      fieldDesignChanges,
      dsToPayItemNoGeometries,
      comments,
      statusId,
      organization,
      submittedBy,
      submittedDate,
      deleted,
      customFields,
    }) => {
      return {
        additionalInfo: [
          {
            label: 'Submitted By',
            type: 'default',
            children: <SingleUser {...submittedBy} />,
          },
          {
            label: 'Submitted Date',
            type: 'date',
            date: submittedDate,
          },
          {
            label: 'Submitting Organization',
            type: 'default',
            children: organization.name,
          },
          {
            type: 'payItems',
            payItems: dsToPayItemNoGeometries.map(({ payItem }) => payItem),
            object: 'Design Submittal',
          },
          {
            label: 'Field Design Changes',
            type: 'deepLinks',
            showMore: { key: id },
            links: fieldDesignChanges.map(
              ({ id, formattedNumber, deleted }) => ({
                label: formattedNumber,
                page: CIMSPage.FDCTracker,
                deep: {
                  recordId: id,
                  deleted,
                },
              })
            ),
          },
        ],
        comments: {
          comments,
          permission: Permission.CommentOnDesignSubmittal,
          onSave: async (comment: string) => {
            await createComment({
              variables: {
                input: { submittalId: id, text: comment },
              },
            })
            await refetch()
          },
        },
        customFields: {
          recordInactive: deleted,
          alreadyDisabled:
            statusId === DSStatus.ReturnedToDesignBuilder.id
              ? {
                  why: 'invalid status',
                  statusName: DSStatus.ReturnedToDesignBuilder.name,
                }
              : false,
          customFields,
          booleanValueOptions: {
            onCheck: async (booleanInput) => {
              await edit({
                id,
                customFields: { booleanInputs: [booleanInput] },
              })
              refetch()
            },
          },
          listValueOptions: {
            onCheck: async (checkbox) => {
              await edit({
                id,
                customFields: { listInputs: { checkboxes: [checkbox] } },
              })
              refetch()
            },
          },
        },
      }
    },
  }
}
